// The string-message $bvToast.toast contract used by Dynabook. CSS/DOM classes
// follow BootstrapVue 2.21.2; this module does not load its Vue 2 runtime.
const activeToasts = new Map()
let sequence = 0
export const toastService = {
  toast(message, options = {}) {
    const id = options.id || `yega-toast-${++sequence}`
    if (activeToasts.has(id)) return
    const placement = options.toaster || 'b-toaster-top-right'
    let container = document.getElementById(placement)
    if (!container) {
      container = document.createElement('div')
      container.id = placement
      container.className = `b-toaster ${placement}`
      const slot = document.createElement('div')
      slot.className = 'b-toaster-slot'
      container.append(slot)
      document.body.append(container)
    }
    const wrapper = document.createElement('div')
    wrapper.id = id
    wrapper.className = [
      'b-toast',
      options.solid && 'b-toast-solid',
      options.variant && `b-toast-${options.variant}`
    ]
      .filter(Boolean)
      .join(' ')
    wrapper.setAttribute('role', options.isStatus ? 'status' : 'alert')
    wrapper.setAttribute('aria-live', options.isStatus ? 'polite' : 'assertive')
    wrapper.setAttribute('aria-atomic', 'true')
    const toast = document.createElement('div')
    toast.className = 'toast show'
    toast.tabIndex = 0
    const header = document.createElement('div')
    header.className = 'toast-header'
    if (options.title) {
      const title = document.createElement('strong')
      title.className = 'mr-2'
      title.textContent = options.title
      header.append(title)
    }
    let timer
    let started
    let remaining = Math.max(Number(options.autoHideDelay ?? 5000) || 0, 1000)
    const remove = () => {
      clearTimeout(timer)
      wrapper.remove()
      activeToasts.delete(id)
      if (!container.querySelector('.b-toast')) container.remove()
    }
    const schedule = () => {
      started = Date.now()
      timer = setTimeout(remove, remaining)
    }
    if (!options.noCloseButton) {
      const close = document.createElement('button')
      close.type = 'button'
      close.className = 'close ml-auto mb-1'
      close.setAttribute('aria-label', 'Close')
      const glyph = document.createElement('span')
      glyph.setAttribute('aria-hidden', 'true')
      glyph.textContent = '×'
      close.append(glyph)
      close.onclick = remove
      header.append(close)
    }
    if (header.childNodes.length) toast.append(header)
    const body = document.createElement('div')
    body.className = 'toast-body'
    body.textContent = String(message)
    toast.append(body)
    wrapper.append(toast)
    const slot = container.firstElementChild
    if (options.appendToast) slot.append(wrapper)
    else slot.prepend(wrapper)
    activeToasts.set(id, remove)
    if (!options.noAutoHide) {
      schedule()
      if (!options.noHoverPause) {
        wrapper.onmouseenter = () => {
          if (!timer) return
          clearTimeout(timer)
          timer = null
          remaining = Math.max(remaining - (Date.now() - started), 1000)
        }
        wrapper.onmouseleave = () => {
          if (!timer) schedule()
        }
      }
    }
  },
  hide(id) {
    if (id) activeToasts.get(id)?.()
    else for (const remove of activeToasts.values()) remove()
  }
}
